<div class="modal">
    <div class="modal-content">
      <span class="modal-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24"><path fill="currentColor" d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.22 0z"/></svg>
      </span>
      <h2>{{ 'candidateProfiling.flow.intro.title' | translate }}</h2>
      <p>{{ 'candidateProfiling.flow.intro.text' | translate }}</p>

      <!-- What happens next: done, now, and our promise -->
      <p class="journey-label" id="journey-label">{{ 'candidateProfiling.flow.intro.journey' | translate }}</p>
      <ol class="journey" aria-labelledby="journey-label">
        <li class="journey-step journey-step--done">
          <span class="journey-dot" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
          </span>
          <strong>{{ 'candidateProfiling.flow.intro.experience' | translate }}</strong>
          <span>{{ 'candidateProfiling.flow.intro.imported' | translate }}</span>
        </li>
        <li class="journey-step journey-step--current">
          <span class="journey-dot" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6"/></svg>
          </span>
          <strong>{{ 'candidateProfiling.flow.intro.preferences' | translate }}</strong>
          <span>{{ 'candidateProfiling.flow.intro.oneMinute' | translate }}</span>
        </li>
        <li class="journey-step journey-step--promise">
          <span class="journey-dot" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          </span>
          <strong>{{ 'candidateProfiling.flow.intro.contact' | translate }}</strong>
          <span>{{ 'candidateProfiling.flow.intro.always' | translate }}</span>
        </li>
      </ol>


      <div class="actions">
        <button mat-raised-button color="primary" class="linkedin-button" (click)="closeModal()">{{ 'candidateProfiling.flow.intro.continue' | translate }}</button>
      </div>
    </div>
  </div>
